export enum Width {
  NARROW = 'narrow',
  DEFAULT = 'default',
  WIDE = 'wide',
  FULL = 'full',
}

export enum Variant {
  DEFAULT = 'default',
  FADE = 'fade',
  OUTLINE = 'outline',
  GHOST = 'ghost',
}

export enum PillVariant {
  DEFAULT = 'default',
  FADE = 'fade',
  OUTLINE = 'outline',
  CIRCLE = 'circle',
}

export enum Size {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum ColorTheme {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  FOREGROUND = 'foreground',
  BACKGROUND = 'background',
  DANGER = 'danger',
}

export enum ColorHue {
  RED = 'red',
  AMBER = 'amber',
  YELLOW = 'yellow',
  GREEN = 'green',
  TEAL = 'teal',
  BLUE = 'blue',
  INDIGO = 'indigo',
  PINK = 'pink',
  GREY = 'grey',
}

export enum Icons {
  ACTIVITY = 'activity',
  ADMIN = 'admin',
  ASSESSMENT = 'assessment',
  ATTACHMENT = 'attachment',
  BIN = 'bin',
  BIN_FILLED = 'bin-filled',
  BOOK = 'book',
  BRAIN = 'brain',
  CALENDAR = 'calendar',
  CALENDAR_SCHEDULE = 'calendar-schedule',
  CHEVRON_DOWN = 'chevron-down',
  CHEVRON_LEFT = 'chevron-left',
  CHEVRON_RIGHT = 'chevron-right',
  CHEVRON_UP = 'chevron-up',
  CLASS = 'class',
  CLOCK = 'clock',
  COPY = 'copy',
  CROSS = 'cross',
  DOWNLOAD = 'download',
  DUPLICATE = 'duplicate',
  EXTERNAL_LINK = 'external-link',
  EYE = 'eye',
  FEEDBACK = 'feedback',
  FLASK = 'flask',
  FRAMEWORK = 'framework',
  GEAR = 'gear',
  ELLIPSIS = 'ellipsis',
  GRID = 'grid',
  HELP = 'help',
  INFO_TIP = 'info-tip',
  LESSON = 'lesson',
  LINK = 'link',
  LIST = 'list',
  LOCK_CLOSED = 'lock-closed',
  LOCK_CLOSED_FILLED = 'lock-closed-filled',
  LOCK_OPEN = 'lock-open',
  LOCK_OPEN_FILLED = 'lock-open-filled',
  MAGIC = 'magic',
  PENCIL_CHECK = 'pencil-check',
  PLUS = 'plus',
  PRINT = 'print',
  PRINTER_CHECK = 'printer-check',
  QUESTION = 'question',
  RISK_ASSESS = 'risk-assess',
  ROCKET = 'rocket',
  SCHOOL = 'school',
  SEARCH = 'search',
  SETTINGS = 'settings',
  SHIELD = 'shield',
  SIGN_OUT = 'sign-out',
  SKILL = 'skill',
  SLIDE_DECK = 'slide-deck',
  SORT_DOWN = 'sort-down',
  SORT_INACTIVE = 'sort-inactive',
  SORT_UP = 'sort-up',
  STAR = 'star',
  STORAGE_BOX = 'storage-box',
  STUDY_NOTES = 'study-notes',
  SUCCESS = 'success',
  TASK = 'task',
  TEXTBOOK = 'textbook',
  TICK = 'tick',
  UNIT_PLAN = 'unit-plan',
  VIDEO_LESSON = 'video-lesson',
  WORKSHEET = 'worksheet',
}

export enum Placement {
  TOP_START = 'top-start',
  TOP = 'top',
  TOP_END = 'top-end',
  RIGHT_START = 'right-start',
  RIGHT = 'right',
  RIGHT_END = 'right-end',
  BOTTOM_START = 'bottom-start',
  BOTTOM = 'bottom',
  BOTTOM_END = 'bottom-end',
  LEFT_START = 'left-start',
  LEFT = 'left',
  LEFT_END = 'left-end',
}
